import utils from '~/utils';

const { getFullDate } = utils;

export default [
  {
    width: 15,
    header: {
      type: 'text',
      caption: 'Requisite name',
    },
    cell: {
      type: 'text',
      value: (e) => e.name,
    },
  },
  {
    width: 15,
    header: {
      type: 'text',
      caption: 'Profile name',
    },
    cell: {
      type: 'text',
      value: (e) => e.profileName,
    },
  },
  {
    width: 15,
    header: {
      type: 'text',
      caption: 'Fileds',
    },
    cell: {
      type: 'slot',
      name: 'fields',
    },
  },
  {
    width: 10,
    header: {
      type: 'text',
      caption: 'Status',
    },
    cell: {
      type: 'slot',
      name: 'status',
    },
  },
  {
    width: 15,
    header: {
      type: 'text',
      caption: 'Date created',
      sort: 'dateCreated',
    },
    cell: {
      type: 'text',
      value: (e) => getFullDate(e.createdAt),
    },
  },
  {
    width: 15,
    header: {
      type: 'text',
      caption: 'Date deleted',
      sort: 'dateDeleted',
    },
    cell: {
      type: 'text',
      value: (e) => {
        if (e.isDeleted) {
          return getFullDate(e.deletedAt);
        }
        return '–';
      },
    },
  },
  {
    width: 25,
    header: {
      type: 'text',
      caption: 'Payment Method',
    },
    cell: {
      type: 'text',
      value: (e) => e.paymentMethodName,
    },
  },
];
